import { render } from "./SessionAddProtcolModal.vue?vue&type=template&id=4ff5d67f&scoped=true"
import script from "./SessionAddProtcolModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SessionAddProtcolModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./SessionAddProtcolModal.vue?vue&type=style&index=0&id=4ff5d67f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff5d67f"]])

export default __exports__